import React from 'react';
import { EmailPreferencePageContent } from 'services/content'; //
import styles from './style.module.css';
import { useFormik } from 'formik';
import { useHistory } from 'react-router-dom';
import useConsent from 'hooks/useConsent';
import { Spinner, BackPage } from 'components';

const EmailPreferences = () => {
  const history = useHistory();
  const [consents, loading, putConsents] = useConsent();

  const getInitialValues = () => {
    return loading
      ? {
          'consent-user-research': '',
          'consent-marketing': '',
        }
      : {
          'consent-user-research': consents['user_research_email_consent'] ? 'on' : '',
          'consent-marketing': consents['news_email_consent'] ? 'on' : '',
        };
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: getInitialValues(),
    onSubmit: async (values) => {
      const reqBody = {
        news_email_consent: String(values['consent-marketing']) === 'on' ? true : false,

        order_updates_push_notification_consent: consents['order_updates_push_notification_consent'],
        user_research_email_consent: String(values['consent-user-research']) === 'on' ? true : false,
      };
      await putConsents(reqBody);
    },
  });

  return (
    <>
      {loading && <Spinner />}
      <div className={loading ? styles.invisible : null}>
        <BackPage onBackClick={() => history.goBack()}>
          <form onSubmit={formik.handleSubmit} className={`${styles.consent_page}`}>
            <h1>{EmailPreferencePageContent.headingText}</h1>
            <h2>{EmailPreferencePageContent.subHeadingText1}</h2>
            <p>{EmailPreferencePageContent.paragraphText1}</p>
            <div className={styles.info_container}>
              <div className="coop-form__choice">
                <input
                  id="consent-user-research"
                  className={`coop-form__field coop-form__checkbox ${styles.info_container__input}`}
                  checked={String(formik.values['consent-user-research']) === 'on'}
                  onChange={formik.handleChange}
                  type="checkbox"
                />
                <label
                  id="label-consent-user-research"
                  htmlFor="consent-user-research"
                  className={`${styles.info_container__choice} coop-form__label`}
                  dangerouslySetInnerHTML={{ __html: EmailPreferencePageContent.tickBoxText1 }}
                />
              </div>
            </div>
            <h2>{EmailPreferencePageContent.subHeadingText2}</h2>
            <p>{EmailPreferencePageContent.paragraphText2}</p>
            <div className={styles.info_container}>
              <div className="coop-form__choice">
                <input
                  id="consent-marketing"
                  className={`coop-form__field coop-form__checkbox ${styles.info_container__input}`}
                  checked={String(formik.values['consent-marketing']) === 'on'}
                  onChange={formik.handleChange}
                  type="checkbox"
                />
                <label
                  id="label-consent-marketing"
                  htmlFor="consent-marketing"
                  className={`${styles.info_container__choice} coop-form__label`}
                  dangerouslySetInnerHTML={{ __html: EmailPreferencePageContent.tickBoxText2 }}
                />
              </div>
            </div>
            <p
              dangerouslySetInnerHTML={{
                __html: EmailPreferencePageContent.endingText,
              }}
            />
            <button type="submit" className={`coop-btn coop-btn--primary ${styles.button}`} id="continuelink">
              {EmailPreferencePageContent.submitButtonText}
            </button>
          </form>
        </BackPage>
      </div>
    </>
  );
};

export default EmailPreferences;
